import React, { useState } from 'react';
// import { isMobile } from 'react-device-detect';
import LoadingScreen from '../../components/Complements/LoadingScreen';
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, List, ListItem, ListItemAvatar, ListItemText, Paper, Typography } from '@material-ui/core';
// import { useTheme } from '@emotion/react';
import { DataGrid } from '@mui/x-data-grid';
// import { esES } from '@mui/x-data-grid/locales';
import SendValidationPayrollForm from '../../components/Payrolls/SendValidationPayrollForm';
import { getDeviceInfo } from '../../services/devices';
import { decrypt, encrypt } from '../../functions/mobile';
import { feathersCreateData, feathersFindDataAll } from '../../services';
import ShowValidators from '../../components/Payrolls/ShowValidators';
// import { ArrowBackIos } from '@material-ui/icons';
// import { checkPermissionUser } from './../../functions/permissions-functions';
import { useSelector } from 'react-redux';
import { history } from '../../helpers/history';
import DialogOTP from '../../components/Complements/DialogOTP';
// import { useTheme } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const ValidatePayRoleComponent = props => {
  const { handleOpenSnack, dataPayrollTray, accountSelected, dataPayrolls,
    dataValidators, user } = props
  //console.log('los dataValidators son', dataValidators, user);
  // console.log('el user es', user);
  // const theme = useTheme();
  const permissions = useSelector((state) => state.permissions);

  const [openDialogOTP, setOpenDialogOTP] = useState(false);
  const [showValidators, setShowValidators] = useState(false);
  const [initialTime, setInitialTime] = useState(Date.now());
  const [timeLifeToken, setTimeLifeToken] = useState(180000);
  const [loading, setLoading] = useState(false);
  const [dataConcept, setDataConcept] = useState('');
  const [dataDecision, setDataDecision] = useState('');

  const columns = [
    {
      field: 'identification',
      headerName: 'Identificación',
      flex: 1,
      sortable: false,
    },
    {
      field: 'name',
      headerName: 'Nombres',
      flex: 2,
      sortable: false,
    },
    {
      field: 'account',
      headerName: 'Cuenta destino',
      flex: 1,
      sortable: false,
      // valueGetter: (params) => params.row.account.substring(4),
    },
    {
      field: 'account_type',
      headerName: 'Tipo Cuenta',
      flex: 1,
      sortable: false,
    },
    {
      field: 'value',
      headerName: 'Valor',
      flex: 1,
      sortable: false,
      valueGetter: (params) => `$ ${parseFloat(params.row.value).toFixed(2)}`,
    },
{
  field: 'inst_code',
  headerName: 'Institución',
  flex: 2,
  sortable: false,
  renderCell: (params) => (
    <div style={{
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      lineHeight: '1.2',
      overflowWrap: 'break-word'
    }}>
      {params.value}
    </div>
  ),
},
  ];

  const handleCloseDialogOTP = () => {
    setOpenDialogOTP(false);
    setLoading(false);
  };

  const handleChangeInputOtp = (valueInputOtp) => {
    if (valueInputOtp.toString().length === 6) {
      receiveOTP({ data: valueInputOtp.toString() });
    }
  };

  const onKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      ev.preventDefault()
    } else {
      if (ev.target.value.toString().length === 6) {
        receiveOTP({ data: ev.target.value });
      }
    }
  }

  const receiveOTP = async (value) => {
    try {
      setLoading(true);
      let resultDevice = {};
      const deviceInfo = await getDeviceInfo(null);
      //console.log('deviceInfo', deviceInfo);
      resultDevice = deviceInfo.data;
      const { ip, device, mac } = resultDevice;

      const sendData = encrypt(JSON.stringify({
        ip,
        mac,
        device,
        type: 26,
        inputOtp: value.data,
      }));

      const responseValidateCode = await feathersCreateData('code-validation', { sendData })();

      console.log('Respuesta: ', responseValidateCode);

      const { error, message, type, viewDialogOtp } = responseValidateCode;

      if (error === false) {
        handleCloseDialogOTP();
        sendPayrollDecision(value.data)
      } else {
        if (viewDialogOtp === false) {
          handleCloseDialogOTP();
        }
        handleOpenSnack(message, type);
        setLoading(false);
      }
    } catch (error) {
    }
  }

  const sendPayrollDecision = async (otp) => {
    try {
      setLoading(true);
      const deviceInfo = await getDeviceInfo(null);
      console.log({
        service: 'PROCESS_PAYROLL',
        // nomina: dataJson,
        ...deviceInfo.data,
        state: dataDecision,
        otp,
        totalAmount: dataPayrollTray.value,
        accountSequential: accountSelected.PRODUCTBANKID,
        payroll: dataPayrollTray.id,
        observation: dataConcept
      })
      // const { ip, device, mac } = deviceInfo;
      feathersCreateData('payrolls-control', {
        service: 'PROCESS_PAYROLL',
        // nomina: dataJson,
        ...deviceInfo.data,
        otp,
        state: dataDecision,
        totalAmount: dataPayrollTray.value,
        accountSequential: accountSelected.PRODUCTBANKID,
        payroll: dataPayrollTray.id,
        observation: dataConcept
      })().then(res => {
        const { error } = res
        if (error) {
          handleOpenSnack(res.message, 'error');
        } else {
          handleOpenSnack(res.message, 'success');
          history.push('/');
        }
        setLoading(false);
      }).catch(err => {
        setLoading(false);
      })
    } catch (error) {
      setLoading(false);
    }
  }
  const sendDatatoPayroll = async (dataForm, action) => {
    try {
      if (action === 'approve') {
        const company = await feathersFindDataAll('companies', { id: user.company })();
        if (parseFloat(dataPayrollTray.value) > parseFloat(accountSelected.SALDO)) {
          handleOpenSnack('El saldo es insuficiente para realizar la transacción.', 'error')
        } else if (parseFloat(dataPayrollTray.value) > parseFloat(company[0].max_amount)) {
          handleOpenSnack('El valor excede el monto maximo permitido por la empresa', 'error')
        } else {
          setDataConcept(dataForm.observation)
          setDataDecision(action)
          requestOtp()
        }
      } else {
        setDataConcept(dataForm.observation)
        setDataDecision(action)
        requestOtp()
      }

    } catch (error) {
    }
  }

  const requestOtp = async () => {
    try {
      let resultDevice = {};
      let values = {}
      setLoading(true);
      const deviceInfo = await getDeviceInfo(null);

      resultDevice = deviceInfo.data;
      const { ip, device, mac } = resultDevice;
      values.ip = ip;
      values.mac = mac;
      values.device = device;
      const sendData = encrypt(JSON.stringify({ emited: 'NAVCREATECODE', values, type: 26, deviceData: device, ip, mac }));

      const responseCode = await feathersCreateData('codes-recovery', { sendData })();
      const jsonDecrypt = JSON.parse(decrypt(responseCode.responseData));
      const { type, result, timeLifeToken } = jsonDecrypt;
      if (type === 'success') {
        // setValuesLogin(values);
        //handleOpenSnack(result, type)
        setInitialTime(Date.now());
        setOpenDialogOTP(true);
        setLoading(false);

        setTimeLifeToken(timeLifeToken);
      } else {
        setLoading(false);
        handleOpenSnack(result, type);
      }
    } catch (error) {
      setLoading(false)

    }
  };

  const renderData = () => (
    <Box style={{ width: '100%' }}>

      <DataGrid
        autoHeight
        // className='table-style'
        columns={columns}
        // disableColumnSelector
        // pagination
        // // localeText={esES.components.MuiDataGrid.defaultProps.localeText}

        isRowSelectable={() => false}
        rows={dataPayrolls}
        localeText={{
          columnsPanelShowAllButton: 'Show all', // ocultamos el texto "Show all"
          columnsPanelHideAllButton: '', // ocultamos el texto "Hide all"
        }}
      // keepNonExistentRowsSelected
      // getRowId={(row) => row.identification}
      // initialState={{
      //   pagination: { paginationModel: { pageSize: 5 } },
      // }}
      // pageSizeOptions={[5, 10, 25, { value: -1, label: 'All' }]}
      />
    </Box>
  );

  const renderBody = () => (
    dataPayrolls.length === 0 ?
      <>
        <Alert severity='info'>
          Actualmente no tienes nóminas cargadas
        </Alert>
      </>
      :
      <Paper elevation={0} style={{ margin: '16px', borderRadius: '16px' }}>
        <Box
          flex={1}
          flexWrap='wrap'
          flexDirection='column'
          width="calc(100% - 30px)"
          margin="0 auto"
          style={{
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            overflow: 'hidden',
            // backgroundColor: theme.palette.secondary.main
          }}
        >
          <Box flex={1} flexWrap='wrap' borderRadius='20px' padding={1.5} sx={{ backgroundColor: 'transparent' }}>

            <Typography component="span" style={{ fontWeight: 'bold', color: 'black', padding: 2 }}>
              Cuenta Seleccionada:
            </Typography>
            <Typography component="span" style={{ fontWeight: 'bold', marginLeft: 0.5 }}>
              {accountSelected.PRODUCTBANKID}
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            flexWrap="wrap"
            borderRadius="20px"
            padding={1.5}
            gap={2} // espacio entre columnas
          >
            <Box flex={1}>
              <List>
                <ListItem button onClick={() => setShowValidators(true)}>
                  <ListItemAvatar>
                    <Avatar>{'$'}</Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<span>Estado</span>}
                    secondary={<span>{dataPayrollTray.state}</span>}
                  />
                </ListItem>
              </List>
            </Box>
            <Box flex={1}>
              <List>
                <ListItem onClick={() => console.log('clic')}>
                  <ListItemAvatar>
                    <Avatar>{'$'}</Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<span>Saldo Disponible</span>}
                    secondary={<span>${
                      (permissions.includes(11)) ?
                        accountSelected.SALDO :
                        '****'
                    }</span>}
                  />
                </ListItem>
              </List>
            </Box>
          </Box>
        </Box>
        <Box display='flex' flex={1} flexWrap='wrap' flexDirection='column' style={{ paddingTop: 1 }} >
          <SendValidationPayrollForm
            onSubmit={sendDatatoPayroll}
            validator={dataValidators ? dataValidators.find(dv => dv.cedule === user.identification) : {}}
            dataTotal={dataPayrollTray.value}>
            {renderData()}
          </SendValidationPayrollForm>
        </Box>
      </Paper>
  );
  return (
    <>
      {renderBody()}

      <LoadingScreen
        open={loading}
      />
      <DialogOTP
        openDialogOTP={openDialogOTP}
        onCloseDialogOTP={() => setOpenDialogOTP(false)}
        initialTime={initialTime}
        loading={loading}
        showQR={false}
        OTPSubmit={receiveOTP}
        handleChangeInputOtp={handleChangeInputOtp}
        onKeyPress={onKeyPress}
        timeLifeToken={timeLifeToken}
      />
      <Dialog
        fullScreen
        onClose={() => setShowValidators(false)}
        open={showValidators}>
        <DialogContent>
          <ShowValidators dataValidators={dataValidators} />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setShowValidators(false)}>
            Salir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

ValidatePayRoleComponent.propTypes = {

};

export default ValidatePayRoleComponent;
